@if (result) {
  <div class="sc-dialog-wrapper --divider">
    <div class="m3-dialog-header">
      <mat-icon
        class="m3-dialog-icon"
        [ngClass]="{
          'text-success': result.is_correct,
          'text-danger': !result.is_correct,
        }"
        >{{ result.is_correct ? 'trophy' : 'close' }}</mat-icon
      >
      <h2 class="m3-dialog-headline">
        {{
          (result.is_correct ? 'trial_exam_passed' : 'trial_exam_failed')
            | translate
        }}
        <!-- {{ 'trial_exam_result' | translate }} -->
      </h2>
      <!-- <p class="m3-dialog-supporting-text">
        {{
          (result.is_correct
            ? 'trial_exam_result_successful'
            : 'trial_exam_result_failed'
          ) | translate
        }}
      </p> -->
    </div>
    <div
      mat-dialog-content
      style="
        --mat-dialog-content-padding: 0 var(--md-sys-size-2);
        --mat-dialog-with-actions-content-padding: 0;
        --mdc-dialog-supporting-text-color: var(--md-sys-color-on-surface);
      "
    >
      <div
        class="my-3"
        style="--mat-table-background-color: var(--mdc-dialog-container-color)"
      >
        <table mat-table [dataSource]="dataSource" class="px-6">
          <ng-container matColumnDef="category">
            <th mat-header-cell *matHeaderCellDef style="width: 50%"></th>
            <td mat-cell *matCellDef="let element">
              {{ element.category_name }}
            </td>
            <td mat-footer-cell *matFooterCellDef>
              {{ 'total' | translate }}
            </td>
          </ng-container>
          <ng-container matColumnDef="count_correct">
            <th mat-header-cell *matHeaderCellDef style="width: 160px">
              {{ 'count_correct' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.count_correct ? element.count_correct : 0 }}
            </td>
            <td mat-footer-cell *matFooterCellDef>
              {{ result.count_correct }}
            </td>
          </ng-container>
          <ng-container matColumnDef="count_wrong">
            <th mat-header-cell *matHeaderCellDef style="width: 160px">
              {{ 'count_wrong' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{
                element.count_questions -
                  (element.count_correct ? element.count_correct : 0)
              }}
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>
          <ng-container matColumnDef="count_needed_correct">
            <th mat-header-cell *matHeaderCellDef style="width: 160px">
              {{ 'count_needed_correct' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.count_needed_correct }}
            </td>
            <td mat-footer-cell *matFooterCellDef>
              {{ result.count_needed_correct }}
            </td>
          </ng-container>
          <ng-container matColumnDef="percentage_correct">
            <th mat-header-cell *matHeaderCellDef style="width: 160px">
              {{ 'Percentage_correct' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              @if (element.count_correct) {
                {{
                  (element.count_correct / element.count_questions) * 100
                    | number: '1.0-2'
                }}&nbsp;%
              } @else {
                0&nbsp;%
              }
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef style="width: 160px">
              {{ 'Passed' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              <div style="display: grid; place-items: center">
                @if (element.count_correct >= element.count_needed_correct) {
                  <mat-icon class="text-success" style="--mat-icon-fill: 1">
                    check
                  </mat-icon>
                } @else {
                  <mat-icon class="text-error">close</mat-icon>
                }
                <!-- {{
              element.count_correct >= element.count_needed_correct
              ? 'passed'
              : 'failed'
              }} -->
              </div>
            </td>
            <td mat-footer-cell *matFooterCellDef>
              <div style="display: grid; place-items: center">
                @if (result.is_correct) {
                  <mat-icon class="text-success" style="--mat-icon-fill: 1">
                    check
                  </mat-icon>
                } @else {
                  <mat-icon class="text-error">close</mat-icon>
                }
                <!-- {{
              element.count_correct >= element.count_needed_correct
              ? 'passed'
              : 'failed'
              }} -->
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
        </table>
      </div>
      <dl class="time-stats mb-6">
        <dd>{{ 'Available_time' | translate }}</dd>
        <dt>{{ result.minutes_to_solve }} {{ 'minutes' | translate }}</dt>
        <dd>{{ 'Required_time' | translate }}</dd>
        <dt>
          {{ result.used_time_seconds / 60 | number: '0.0-0' }}
          {{ 'minutes' | translate }}
        </dt>
      </dl>
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="close('ok')">
        <mat-icon>visibility</mat-icon>
        {{ 'Review_exam' | translate }}
      </button>
      @if (!result.is_correct) {
        <button mat-button (click)="close('repeat')">
          <mat-icon>replay</mat-icon>
          {{ 'repeat_test_exam' | translate }}
        </button>
      }
    </div>
  </div>
}
